// removed by extract-text-webpack-plugin
module.exports = {"poster-register-list":"poster-register-list","register-now":"register-now","header":"header","ticket-item-list":"ticket-item-list","index":"index","ticket-item":"ticket-item","date":"date"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/PosterView/Register.scss
// module id = Wo8s
// module chunks = 0